import React from 'react'
import MaterialSymbol from '../material-symbol'

const SportsGolf = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="sports_golf" {...props} />
))

SportsGolf.displayName = 'SportsGolf'

export default SportsGolf
